<template>
  <form-wrapper
    full-width
    full-height
    full-footer
  >
    <template v-slot:body>
      <info-page :validate="validate" />
    </template>
    <template
      v-if="!gettingCertificate"
      v-slot:footer
    >
      <b-button
        variant="bg-white"
        @click="onCancel()"
      >
        Cancel
      </b-button>
      <button-loading
        v-if="validate"
        :spinning="validatingCertificate"
        variant="bg-primary"
        class="ml-16"
        @click="onValidate()"
      >Validate
      </button-loading>
    </template>
  </form-wrapper>
</template>
<script>
import InfoPage from './Info.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'ViewCertificate',
  components: { InfoPage },
  data() {
    return {
      validate: false,
    }
  },
  computed: {
    certificate() {
      return this.$store.state.cdn.certificate
    },
    gettingCertificate() {
      return this.$store.state.cdn.gettingCertificate
    },
    validatingCertificate() {
      return this.$store.state.cdn.validatingCertificate
    },
  },
  created() {
    this.$store
      .dispatch('cdn/getCertificate', this.$route.params.certificateId)
      .then(() => {
        if (this.certificate.certificateStatus !== 'Issued' && this.certificate.certificateStatus !== 'Renewed' && this.certificate.certificateStatus !== 'Auto Validating') {
          this.validate = true
        }
      })
      .catch(err => redirectError(err, this.$router, this.$route.path))
  },
  methods: {
    onCancel() {
      this.$router.push({ name: 'certificates' })
    },
    onValidate() {
      this.$store
        .dispatch('cdn/validateCertificate', this.$route.params.certificateId)
        .then(() => this.onCancel())
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors[0] || 'Something went wrong.',
          )
        })
    },
  },
}
</script>
